import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LetheLogoPNG } from '../../assets';

const Header = (): React.JSX.Element => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <header className="font-inter h-[60px] w-full px-16 flex items-center justify-between bg-transparent py-3 border-b border-gray-700">
      <Link to={'/'}>
        <div className="flex items-center">
          <img
            src={LetheLogoPNG}
            className="w-[60px] h-[60px] mr-3"
            alt="lethe logo"
          />
          <div className="w-full max-w-[260px]">
            <div className="text-lg font-semibold leading-tight text-white">
              lethe
            </div>
            <div className="text-xs text-gray-400">Shielded STRK transfers via Zcash</div>
          </div>
        </div>
      </Link>
    </header>
  );
};

export default Header;
